import "moment/locale/it"
import { PlayerRole } from "../../../types/player"
import { Tabs } from "antd"
import { RetiredPlayerStatType } from "../../../types/retiredPlayerStatType"
import { RetiredPlayerTypeParameterFlat } from "../../../types/retiredPlayerStats"
import { PlayerTypeRetiredStats } from "@components/PlayerRetiredStats/PlayerTypeRetiredStats"

const { TabPane } = Tabs

function retiredPlayerTypeToLabel(type: RetiredPlayerStatType): string {
  let typeLabel = "Club"

  if (type === "club") {
    typeLabel = "Club"
  } else if (type === "national") {
    typeLabel = "Nazionale"
  }

  return typeLabel
}

export function PlayerRetiredTypes({ role, stats }: { role: PlayerRole; stats: RetiredPlayerTypeParameterFlat[] }) {
  return (
    <Tabs defaultActiveKey={"1"} centered>
      {stats.map((retiredPlayerStats, i) => {
        return (
          <TabPane tab={retiredPlayerTypeToLabel(retiredPlayerStats.type)} key={`${i + 1}`}>
            <PlayerTypeRetiredStats role={role} stats={retiredPlayerStats} />
          </TabPane>
        )
      })}
    </Tabs>
  )
}
